export enum StatusNotification {
  Andamento = 0,
  Concluido = 1,
  ConcluidoAlerta = 2,
  Erro = 9
}
